const _abortControllers = {};

export const AbortSignalManager = {
    getFresh: (key: string): AbortSignal => {
        const abortController = _abortControllers[key];
        if (abortController && !abortController.signal.aborted) {
            abortController.abort();
        }

        _abortControllers[key] = new AbortController();
        return _abortControllers[key].signal;
    },
    abort: (abortControllers: string[]) => {
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => {
                if (abortControllers[key] && abortControllers[key].signal && !abortControllers[key].signal.aborted) {
                    abortControllers[key].abort();
                }
            });
        }
    },
};
